import './FeatureFlagManager.scss';
import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { createAsyncSelectors } from '@lib/selectors';
import { objectKeys } from '@sonar-software/sonar-ts-lib';
import omitBy from 'lodash/omitBy';
import pickBy from 'lodash/pickBy';
import { adminActions } from '@sonar-software/sonar-admin';
import { Checkbox, Input, Tooltip } from 'antd';
import { coreActions, FeatureFlagLabel } from '@sonar-software/sonar-core';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useAction, useSonarSelector } from '@hooks';
const getCustomerFeatureFlagsSelectors = createAsyncSelectors((state) => state.core.customers.byId.featureFlags.get);
const searchableFeatureFlags = objectKeys(FeatureFlagLabel).reduce((obj, key) => {
    obj[key] = FeatureFlagLabel[key].toLocaleLowerCase();
    return obj;
}, {});
export const FeatureFlagManager = (props) => {
    const { id, searchDetails } = props;
    const [featureFlagSelections, setFeatureFlagSelections] = useState([]);
    const [featureFlagFilter, setFeatureFlagFilter] = useState('');
    const getCustomerFeatureFlags = useAction(coreActions.requestGetCoreCustomersByIdFeatureFlags);
    const customerFeatureFlags = useSonarSelector(getCustomerFeatureFlagsSelectors.data);
    const customerFeatureFlagOptions = useMemo(() => {
        if (!customerFeatureFlags) {
            setFeatureFlagSelections([]);
            return [];
        }
        const displayedFilter = featureFlagFilter.toLocaleLowerCase();
        const displayed = featureFlagFilter ?
            omitBy(customerFeatureFlags, (value, key) => { var _a; return !((_a = searchableFeatureFlags[key]) !== null && _a !== void 0 ? _a : key.toLocaleLowerCase()).includes(displayedFilter); }) :
            customerFeatureFlags;
        const selections = Object.keys(pickBy(displayed, (value) => value));
        setFeatureFlagSelections(selections);
        return Object.keys(displayed).map((key) => {
            var _a;
            return ({
                checked: customerFeatureFlags[key],
                label: React.createElement(Tooltip, { title: key }, (_a = FeatureFlagLabel[key]) !== null && _a !== void 0 ? _a : key),
                value: key
            });
        });
    }, [customerFeatureFlags, setFeatureFlagSelections, featureFlagFilter]);
    const handleSearchChanged = useCallback((e) => {
        var _a;
        setFeatureFlagFilter((_a = e.target) === null || _a === void 0 ? void 0 : _a.value);
    }, [setFeatureFlagFilter]);
    const updateFeatureFlags = useAction(adminActions.requestPostAdminCustomersFeatureFlags);
    const handleCheckboxChanged = useCallback((checkedValue) => {
        if (searchDetails) {
            const { customerId, shardName } = searchDetails;
            const selections = checkedValue.map((v) => v.toString());
            setFeatureFlagSelections(selections);
            updateFeatureFlags({
                customerId: customerId,
                flags: selections,
                shardName: shardName
            });
        }
    }, [setFeatureFlagSelections, updateFeatureFlags, searchDetails]);
    useEffect(() => {
        if (searchDetails) {
            const { customerId, shardName } = searchDetails;
            getCustomerFeatureFlags({
                customerId: customerId,
                shardName
            });
        }
    }, [searchDetails, getCustomerFeatureFlags]);
    return (React.createElement("div", { className: 'feature-flag-manager', id: id },
        React.createElement("div", { className: 'h2' }, ADMIN_DASHBOARD_COPY.FEATURE_FLAGS),
        React.createElement(Input.Search, { allowClear: true, className: 'feature-flag-search', enterButton: true, onChange: handleSearchChanged, placeholder: ADMIN_DASHBOARD_COPY.SEARCH_FEATURE_FLAGS_PLACEHOLDER }),
        React.createElement(Checkbox.Group, { onChange: handleCheckboxChanged, options: customerFeatureFlagOptions, value: featureFlagSelections })));
};
